export default "<app-header-pop></app-header-pop>\n<router-outlet></router-outlet>\n<app-footer-pop></app-footer-pop>\n<app-floating-btn></app-floating-btn>";